module.exports = __webpack_public_path__ + "static/img/Ctu2@2x.71ffd680.png";